import { useState } from "react";
import Container from "../../components/utils/Container";
import Aside from "../../components/marketing/pageSections/products/Aside";
import AllProducts from "../../components/marketing/pageSections/products/AllProducts";

const BodyProducts = (props) => {
  return (
    <>
      <Container classe="md:flex md:flex-end md:items-start md:space-x-1.5">
        <Aside />
        <AllProducts />
      </Container>
    </>
  );
};

export default BodyProducts;
